import React from 'react'

import CloseButton from '../CloseButton/CloseButton'
import RestaurantInfo from '../RestaurantInfo/RestaurantInfo'
import { RestaurantConsumer } from '../RestaurantProvider/RestaurantProvider'
import Progress from '../Progress/Progress'
import ScrollToTop from '../ScrollToTop/ScrollToTop'
import { ToastContainer } from 'react-toastify'
import { useAvailability } from '../../utils/availability'
import { CartNotifications } from '../CartNotifications/CartNotifications'

import Cart from '../Cart/Cart'
import style from './CartPage.css'

const { toastContainer, toastWrapper } = style

const CartPage = () => {
  const { loading: availabilityLoading, orderingAvailable } = useAvailability()
  return (
    <div styleName='cartPage'>
      <RestaurantConsumer>
        {({ getRestaurantPath }) => (
          <React.Fragment>
            <ScrollToTop />
            <div styleName='closeButton'>
              <CloseButton data-testid='close-button-cart-page' to={{
                pathname: getRestaurantPath(),
                search: ''
              }} />
            </div>
            {availabilityLoading
              ? <Progress eventData={{ category: 'Cart Page' }} />
              : (
                <React.Fragment>
                  <RestaurantInfo header='Your Order' showDeliveryAddress />
                  <div styleName='notification'>
                    <CartNotifications />
                  </div>
                  <Cart
                    checkoutLink={getRestaurantPath('checkout')}
                    orderingAvailable={orderingAvailable}
                    rectifyApprovalRuleLink={getRestaurantPath()}
                  />
                </React.Fragment>
              )}
            <ToastContainer
              hideProgressBar
              closeButton={false}
              className={toastContainer}
              toastClassName={toastWrapper}
              position={'top-center'}
            />
          </React.Fragment>
        )}
      </RestaurantConsumer>
    </div>
  )
}
CartPage.propTypes = {
}

export default CartPage
